import type {
  HelpScoutMailboxT,
  HelpScoutWorkspaceT,
} from '@/features/Setting/Integrations/providers/types';
import { v1ApiClient } from '@/services';

const helpscoutService = {
  createHelpScoutInfo: async (
    workspaceAlias: string,
    apiKey: string,
    apiSecret: string,
  ): Promise<HelpScoutWorkspaceT> => {
    const res = await v1ApiClient.post(
      `/workspaces/${workspaceAlias}/helpscout`,
      { client_id: apiKey, client_secret: apiSecret },
    );
    return res.data;
  },
  fetchHelpscoutMailboxes: async (
    workspaceAlias: string,
  ): Promise<HelpScoutMailboxT[]> => {
    const res = await v1ApiClient.get(
      `/workspaces/${workspaceAlias}/helpscout/mailboxes`,
    );
    return res.data;
  },
  fetchHelpScounInfo: async (
    workspaceAlias: string,
  ): Promise<HelpScoutWorkspaceT> => {
    const res = await v1ApiClient.get(
      `/workspaces/${workspaceAlias}/helpscout`,
    );
    return res.data;
  },
  updateHelpscoutMailboxes: async (
    workspaceAlias: string,
    mailbox_ids: string[],
  ): Promise<HelpScoutWorkspaceT> => {
    const res = await v1ApiClient.patch(
      `/workspaces/${workspaceAlias}/helpscout/mailboxes`,
      { mailbox_ids: mailbox_ids },
    );
    return res.data;
  },
  importWorkspaceFeedback: async (
    workspaceAlias: string,
    start_date: string,
    end_date: string,
  ) => {
    const res = await v1ApiClient.post(
      `/workspaces/${workspaceAlias}/helpscout/import`,
      { start_date, end_date },
    );
    return res.data;
  },
  deleteHelpScoutInfo: async (workspaceAlias: string) => {
    const res = await v1ApiClient.delete(
      `/workspaces/${workspaceAlias}/helpscout`,
    );
    return res.data;
  },
};

export default helpscoutService;
